<template>
  <el-dialog title="生成策略" class="role-dialog" :visible.sync="dialogFormVisible">
    <el-form :model="form">
      <el-form-item label="作者" :label-width="formLabelWidth">
        <el-input v-model="form.author" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" :label-width="formLabelWidth">
        <el-input v-model="form.email" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="包名" :label-width="formLabelWidth">
        <el-input v-model="form.package" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="自动去掉表前缀" style="text-align: left" :label-width="formLabelWidth">
        <el-checkbox v-model="checked"></el-checkbox>
        <el-input v-model="form.autoRemovePre" autocomplete="off" style="display: none"></el-input>
      </el-form-item>
      <el-form-item label="去掉指定表前缀" :label-width="formLabelWidth">
        <el-input v-model="form.tablePrefix" autocomplete="off"></el-input>

      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="update">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogFormVisible: true,
        checked: false,
        form: {
          author: '',
          email: '',
          package: '',
          autoRemovePre: '',
          tablePrefix: ''
        },
        formLabelWidth: '120px'
      };
    },
    methods: {
      int() {

        this.form.author = '';
        this.form.email = '';
        this.form.package = '';
        this.form.autoRemovePre = '';
        this.form.tablePrefix = '';

        this.$httpTAG({
          url: this.$httpTAG.adornUrl('/business/common/generator/view'),
          method: 'post'
        }).then(r => {
          this.form = r.data.data;
          if (this.form.autoRemovePre == "true") {
            this.checked = true;
          }
        }).finally(r => {})

      },
      update() {
        let parem = {
          author: this.form.author,
          email: this.form.email,
          package: this.form.package,
          autoRemovePre: this.form.autoRemovePre,
          tablePrefix: this.form.tablePrefix
        };
        //let form = this.$qs.stringify(parem);

        this.$httpTAG({
          url: this.$httpTAG.adornUrl('/business/common/generator/update'),
          method: 'post',
          data: parem
        }).then(res => {
          if (res.data.code == 0) {
            this.$notify({
              title: '操作成功！',
              type: 'success',
              offset: 600
            });
            this.dialogFormVisible = false
          } else {
            this.$message({ // 失败
              type: 'fail',
              message: res.data.msg
            })
          }
        })
      }
    },
    watch: {
      checked: function (newC, oldC) {
        if (newC) {
          this.form.autoRemovePre = "true";
        } else {
          this.form.autoRemovePre = "false";
        }
      }
    }
  };
</script>

<style scoped>
  .role-dialog >>> .el-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0 !important;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
    display: flex;
    flex-direction: column;
  }

  .role-dialog >>> .el-dialog__body {
    overflow: auto;
  }
</style>
